import React from 'react';

/**
 * Shown when the app could not confirm the guest session with the API (network / server error)
 * but a token is still present — user can retry without losing the token.
 */
export default function SessionVerifyBanner({ onRetry }) {
  return (
    <div
      className="bg-amber-50 border-b border-amber-200 text-amber-950 px-4 py-3 text-sm text-center"
      role="alert"
    >
      <span className="inline-block mr-2">
        Could not verify your session with the server. Check your connection, then retry.
      </span>
      <button
        type="button"
        className="underline font-medium text-amber-900 hover:text-amber-700"
        onClick={onRetry}
      >
        Retry
      </button>
    </div>
  );
}
